var header_advert = ( function( $ ) {

	var $header_advert;
	var $timer;
	var interval;

	var _init = function() {
		$header_advert = $( '#header-advert' );
		$timer         = $header_advert.find( '.time-remaining' );

		$header_advert.find( '.close-ad' ).on( 'click', _hide_header_advert );

		_setup_timer();
	};

	var _setup_timer = function() {
		var total_time     = $timer.text();
		var $images        = $header_advert.find( '.advert-main' ).find( '.advert-image' );
		var time_per_image = total_time / $images.length;

		if ( !interval ) {
			interval = setInterval(
				function() {
					var time = $timer.text() - 1;
					$timer.text( time );

					if ( time <= 0 ) {
						_hide_header_advert();
						return;
					}

					if ( time % time_per_image === 0 ) {
						var new_image_index = ( ( total_time - time ) / time_per_image );

						$images.addClass( 'hidden' ).removeClass( 'shown' );
						$images.eq( new_image_index ).removeClass( 'hidden' ).addClass( 'shown' );
					}
				},
				1000
			)
		}
	};

	var _hide_header_advert = function() {
		clearInterval( interval );
		$header_advert.slideUp();
	};

	if ( $( '#header-advert' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = header_advert;